import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  bashUrl = '';

  constructor(private http: HttpClient, private router: Router) {
    this.bashUrl = `${environment.baseUrl}/api/employee`;
  }

  getEmployData(filter: any) {
    let url = `${this.bashUrl}?limit=`;
    if (filter.limit) {
      url = `${url}${filter.limit}`;
    }
    if (filter.hasOwnProperty('offset')) {
      url = `${url}&offset=${filter.offset}`;
    }
    if (filter.searchText) {
      url = `${url}&search=${filter.searchText}`;
    }
    if (filter.sortBy && filter.order) {
      url = `${url}&sortBy=${filter.sortBy}&order=${filter.order}`;
    }
    if (filter.id) {
      url = `${url}&&id=${filter.id}`;
    }
    return this.http.get<any>(url);
  }

  getReportingManager(filter: any) {
    return this.http.get<any>(`${this.bashUrl}/reportingTo/${filter.reportingTo}`);
  }

  updateData(input, editId) {
    const mutation = `mutation updateEmployee($input: EmployeeInput, $editId: String! ) {
      updateEmployee(
        input: $input,
        editId: $editId
      ) {
        id
        email
      }}`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: mutation,
      variables: { input, editId },
    });
  }

  createEmploy(input) {
    const mutation = `mutation addEmployee($input: EmployeeInput) {
      addEmployee(
        input: $input
      ) {
        id
        name
      }}`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: mutation,
      variables: { input },
    });
  }

  getEmployEmail() {
    const url = `${this.bashUrl}?onlyEmail=true`;
    return this.http.get<any>(url);
  }

  getEmployByFilter(filterData: any) {
    return this.http.post<any>(`${this.bashUrl}/list`, filterData);
  }

  getEmployeeByEmployeeId(id) {
    const query = `{
      employee(id: "${id}"){ 
        id name title employId yearsExperience education projectComplexity HRTraining workingRegion officeLocation
        licenseCertificate signature photoLink employeeStatus countryExperience companyId applicationRoles language systemKnowledge
        activeSubscriptions PropertyTypeKnowledge stateLicense degree organization address city state country zipcode  
         homeAddress homeCity homeState homeCountry homeZipcode officePhone cellPhone homePhone email 
          firstName lastName startDate endDate compensationMethod department annualCompensation
          employmentType designation assignmentRoles company
          previousExperience propertyTypeExperience professionalFocus productFocus personalityType preferredCommunication hobbiesAndInterests
          reportingManager{
            id photoLink name email title
          }
      } 
    }`
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getReportingManagerByEmployeeId(id) {
    const query = `{
      reports(id: "${id}"){
       id employId name company department email officePhone employmentType photoLink employeeStatus reportingManager{
          name title employId 
          organization address city state country zipcode officePhone cellPhone homePhone email 
          firstName lastName startDate endDate compensationMethod department annualCompensation employeeStatus
          employmentType designation assignmentRoles company reportingManager{
            id photoLink name email title
          }
        }
      }
    }`;
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getAllEmployees() {
    const query = `{
        employees{
          id
          name
          email
          title
          photoLink
        }
      }`;
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getRoleList() {
    const query = `
    {
      projectRoles{
        id
        name
        rid
      }
    }
    `;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  generateEmployeeId() {
    const query = `{
     
        generateEmployeeId
      
    }`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getCompanyList() {
    const query = `{
      customerCompanies(order:[["companyName","ASC"]]){
        id
        companyName
        address
        city
        state
        country
        zipCode   
      }
    }`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getCompanyListByType(type = "Partner") {
    const query = `{
      getCompanyByType(type:"${type}"){
        id
        type
        company{
          id
        companyName
        address
        city
        state
        country
        zipCode}   
      }
    }`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`,
      {
        query: query
      })
  }

  getCompanyByName(companyName=''){
      const query = `{
        getCompanyByName(companyName:"${companyName}"){
          id
          companyName   
        }
      }`;
  
      return this.http.post<any>(`${environment.baseUrl}/api/graphql`,
        {
          query: query
        })
  }


  getEmployeeRoleByEmployeeId(employeeId) {
    const query = `{
    employeeRoleByEmployeeId(employeeId: "${employeeId}"){
      id
      role{
        id
        rid
      }
      staff{
        id
        name
        email
      }

    }}
    `;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getEmployeePerformanceData(employeeId, filters, orders) {
    const query = `query employeePerformance($employeeId:ID!, $filters: [EmployeePerformanceFilter], $orders: [[String]]) {
      employeePerformance (employeeId: $employeeId, filters: $filters, orders: $orders){
        performanceData {
          pid
          jobNumber
          trackerLink
          jobTitle
          dueDate
          timing
          status
          grossJobFee
          allocatedFee
          targetHours
          actualHours
          perHrActual
          perHrBudgeted
          propertyType
          propertySubtype
          jobComplexity
          percentCompleted
          outstandingHrs
          prodEffRatio
          accountManager
          productionManager
          clientCompany
          clientFirstName
          clientMiddleName
          clientLastName
        }
        summaryData {
          grossGeneratedFee
          grossManagedFee
          accountsReceivable
          openCompletePercent
          numberOfOpenAssignments
          unfinishedOpenWork
          remainingWorkHours
          remainingWorkDays
          allocationsOpen
          currentMonthClosed {
            value perHrTarget perHrActual
          }
          previousMonthClosed{
            value perHrTarget perHrActual
          }
          currentQuarterClosed {
            value perHrTarget perHrActual
          }
          previousQuarterClosed {
            value perHrTarget perHrActual
          }
          yearToDateClosed {
            value perHrTarget perHrActual
          }
          allTimeClosed {
            value perHrTarget perHrActual
          }
        }
      }
    }`;

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
      variables: { employeeId: employeeId, filters: filters, orders: orders }
    });
  }

  getTitleOptions() {
    const query = `{
      getUniqueRoleValues {
        role
      }
    }`

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  addEmployeeLicense(input) {
    const mutation = `
    mutation AddEmployeeLicense($input: [EmployeeLicensesInput]) {
      addEmployeeLicense(input: $input) {
        id
        state
        licenseStatus
        appraiser
        appraiserStatus
        typesOfLicense
        number
        originalIssueDate
        issueDate
        expirationDate
        inFile
        link
        employee {
          id
        }
      }
    }`

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: mutation,
      variables: { input },
    });
  }

  getEmployeeLicenseByEmployeeId(employeeId) {
    const query = `
    query Query($employeeId: ID) {
      employeeLicensesByEmployee(employeeId: $employeeId) {
       id
       state
       licenseStatus
       appraiser
       appraiserStatus
       typesOfLicense
       number
       originalIssueDate
       expirationDate
       issueDate
       inFile
       link
       employee {
         id
       }
     } 
     }`
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
      variables: { employeeId },
    });
  }


  getMultiSelectList(field) {
    const query = `
    query Query{
      getMultiSelectList(field: "${field}"){
      
        ${field}
      }
    }
  
    `
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  getEmployeeCompensations(employeeId) {
    const query = `
    query Query{
      getEmployeeCompensationByEmployeeId(employeeId: "${employeeId}"){
        hourlyAmount
        overheadPercent
        feeSplitPercent
        profitPercent
        drawAmount
        id
        employeeId
      }
    }
  
    `
    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: query,
    });
  }

  createEmployeeCompensation(input) {
    const mutation = `
    mutation createEmployeeCompensation($input: EmployeeCompensationInput) {
      createEmployeeCompensation(body: $input) {
        id hourlyAmount overheadPercent feeSplitPercent profitPercent drawAmount employeeId
      }
    }`

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: mutation,
      variables: { input },
    });
  }

  updateEmployeeCompensation(input) {
    const mutation = `
    mutation updateEmployeeCompensation($input: EmployeeCompensationInput) {
      updateEmployeeCompensation(body: $input) {
        id hourlyAmount overheadPercent feeSplitPercent profitPercent drawAmount employeeId
      }
    }`

    return this.http.post<any>(`${environment.baseUrl}/api/graphql`, {
      query: mutation,
      variables: { input },
    });
  }
}
